import React, { useState } from "react";


const AppMenuList = ({mainMenuValue, subMenuValue, mainMenuList, subMenuList, subMenuList2, subMenuValue2, handleMainMenu, handleSubMenu, handleSubMenu2, searchValue, setSearchValue, handleSearch}) => {
  

  return (
    <form noValidate>
      <div className="form-row">
        <div className="col-sm-3 form-group">
          <label className="mb-0" htmlFor="select-main-menu">Select Main Menu</label>
          <span className="text-danger">*</span>
          <select
            className="form-select "
            id="select-main-menu"
            name="select-main-menu"
            placeholder="choose one"
            required
            value={mainMenuValue}
            onChange={handleMainMenu}
          >
            <option value={""}>Choose one...</option>
            {mainMenuList &&
              mainMenuList.length > 0 &&
              mainMenuList.map((menu, index) => {
                return (
                  <option key={index} value={menu.mid}>
                    {menu.name}
                  </option>
                );
              })}
          </select>
        </div>
      {/* </div>
      <div className="form-row"> */}
        <div className="col-sm-3 form-group">
          {/* {mainMenuValue &&
            mainMenuValue !== "" &&
            subMenuList &&
            subMenuList.length > 0 && ( */}
              <div>
                <label className="mb-0"  htmlFor="select-sub-menu">Select Menu</label>
                <span className="text-danger">*</span>
                <select
                  className="form-select "
                  id="select-sub-menu"
                  name="select-sub-menu"
                  placeholder="choose one"
                  required
                  value={subMenuValue}
                  onChange={handleSubMenu}
                  disabled={!(mainMenuValue && mainMenuValue !== "" && subMenuList && subMenuList.length > 0)}
                >
                  <option value={""}>Choose one...</option>
                  {subMenuList &&
                    subMenuList.length > 0 &&
                    subMenuList.map((menu, index) => {
                      return (
                        <option key={index} value={menu.mid}>
                          {menu.name}
                        </option>
                      );
                    })}
                </select>
              </div>
            {/* )} */}
        </div>
        <div className="col-sm-3 form-group">
          {/* {subMenuValue &&
            subMenuValue !== "" &&
            subMenuList2 &&
            subMenuList2.length > 0 && ( */}
              <div>
                <label className="mb-0"  htmlFor="select-sub-menu">Select Sub Menu</label>
                <span className="text-danger">*</span>
                <select
                  className="form-select "
                  id="select-sub-menu"
                  name="select-sub-menu"
                  placeholder="choose one"
                  required
                  value={subMenuValue2}
                  onChange={handleSubMenu2}
                  disabled={!(subMenuValue && subMenuValue !== "" && subMenuList2 && subMenuList2.length > 0)}
                >
                  <option value={""}>Choose one...</option>
                  {subMenuList2 &&
                    subMenuList2.length > 0 &&
                    subMenuList2.map((menu, index) => {
                      return (
                        <option key={index} value={menu.mid}>
                          {menu.name}
                        </option>
                      );
                    })}
                </select>
              </div>
            {/* )} */}
        </div>
        {
          handleSearch && setSearchValue && <div className="col-sm-3 form-group">
          <div className='form-inline ' 
            style={{
            // justifyContent:'end'
            marginTop:"23px"
            }}
            >
                
              <input 
                value={searchValue}
                onChange={(e)=>setSearchValue(e.target.value)} 
                style={{width: "70%"}} 
                className="form-control"
                placeholder="Search..."
              ></input>
              
              <button 
                style={{width:'20%'}} 
                className=" btn btn-primary "
                onClick={handleSearch}  
              >
                <i className="fa fa-search"></i>
              {/* Search */}
              </button>
              </div>
        </div>
        }
      </div>
          
    </form>
  );
};

export default AppMenuList;
